import { defineMessages } from 'react-intl';

export default defineMessages({
  shipFrom: {
    description: 'markAsShipped > columns > shipFrom',
    defaultMessage: 'Ship From',
    id: 'KjTLfx',
  },
  shipFromDisclaimer: {
    description: 'markAsShipped > columns > shipFrom > disclaimer',
    defaultMessage: 'Ship From locations will only display if associated to an inventory source',
    id: '/1BsEx',
  },
});
